import React, { useMemo } from 'react'
import { createPortal } from 'react-dom'

import Button from 'devextreme-react/button'

import './floating-buttons.scss'


export const IxFloatingButtons = ({ show, visible, buttonsConfig }: any) => {
    const portalEl = useMemo(() => document.getElementById('speed-actions-container'), [])

    return (
        <>
            {
                show && portalEl && createPortal(
                    <div style={ { display: 'flex', flexDirection: 'column' } }>
                        { buttonsConfig.map((b: any, i: number) => (
                            <Button
                                key={i}
                                elementAttr={ { class: visible ? 'floating-action-btn' : 'floating-action-btn floating-action-btn-hidden' } }
                                type='default'
                                stylingMode='contained'
                                { ...b }
                            />
                        )) }
                    </div>,
                    portalEl
                )
            }
        </>
    )
}
